<template>
  <div class="input-number">
    <div class="icon-wrapper">
      <i
        slot="prepend"
        class="icon-minus minus"
        :class="{
          'is-disabled': conut <= min
        }"
        @click="clickMinus"
      />
    </div>
    <div>
      <input
        v-model="conut"
        type="number"
        onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code !=='Space'"
        @input="input"
      >
    </div>
    <div class="icon-wrapper">
      <i
        slot="append-outer"
        class="icon-plus plus"
        :class="{
          'is-disabled': conut >= max
        }"
        @click="clickPlus"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'min', 'max', 'isShoppingCartMode', 'disabled'],
  data () {
    return {
      conut: 0
    }
  },
  watch: {
    // prop 更新裡面也同步
    value (newVal) {
      this.conut = parseInt(newVal)
    }
  },
  created () {
    this.conut = parseInt(this.value)
  },
  methods: {
    async input (evt) {
      const val = evt.target.value
      const checkCanRemove = () => new Promise((resolve) => {
        if ((Number(val) < 1) && this.isShoppingCartMode === true) {
          this.$alert({
            title: '系統提示',
            message: '確定要移除當前品項嗎？',
            persistent: true,
            btn: [
              {
                btnText: '取消',
                btnClick: () => {
                  this.$alert.close()
                  this.conut = this.value
                  resolve(false)
                }
              },
              {
                btnText: '確定',
                btnColor: 'primary',
                btnClick: () => {
                  this.$alert.close()
                  resolve(true)
                }
              }
            ]
          })
        } else return resolve(true)
      })
      if (this.disabled) {
        this.conut = this.value
      } else if (val === '0') {
        this.conut = 1
      } else if (!await checkCanRemove()) {
        return
      } else if (parseInt(val) >= this.max) {
        this.conut = Number(this.max)
      } else if (parseInt(val) < this.min) {
        this.conut = Number(this.min)
      } else {
        this.conut = Number(val)
      }
      if (this.conut === 0) {
        this.conut = ''
      }
      this.$emit('input', Number(this.conut))
    },
    clickMinus () {
      if (this.conut <= this.min) return
      const triggerMinus = () => {
        this.conut = Number(this.conut) - 1
        this.$emit('input', this.conut)
      }
      if ((this.conut <= 1) && this.isShoppingCartMode === true) {
        this.$alert({
          title: '系統提示',
          message: '確定要移除當前品項嗎？',
          persistent: true,
          btn: [
            {
              btnText: '取消',
              btnClick: () => {
                this.$alert.close()
              }
            },
            {
              btnText: '確定',
              btnColor: 'primary',
              btnClick: () => {
                this.$alert.close()
                triggerMinus()
              }
            }
          ]
        })
      } else {
        triggerMinus()
      }
    },
    clickPlus () {
      if (this.conut >= this.max) return
      this.conut = Number(this.conut) + 1
      this.$emit('input', this.conut)
    }
  }
}
</script>

<style lang="scss" scoped>
$inputHeight: pxTorem(28px);
$defaultColor: #999999;
.input-number {
  font-weight: 600;
  display: flex;
  align-items: center;
  &.active {
    ::v-deep {
      .v-input__slot {
        border-color: $mainColor;
      }
    }
  }
  .icon-wrapper {
    height: $inputHeight;
    line-height: $inputHeight;
    width: $inputHeight;
    display: inline-flex;
    i {
      line-height: $inputHeight;
      width: 100%;
      height: 100%;
      text-align: center;
      color: $mainColor;
      border: solid 1px $mainColor;
      border-radius: 3px;
      cursor: pointer;
      &.is-disabled {
        color: $defaultColor;
        border: solid 1px $defaultColor;
        cursor: default;
        ::v-deep {
          .v-input__slot {
            border: 1px solid $defaultColor;
          }
        }
      }
    }
  }
  input {
    color: $mainColor;
    min-width: 30px;
    max-width: 35px;
    text-align: center;
    font-size: 16px;
  }
}
</style>
